var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.75L4.875 6.375H13.125L14.25 9.75M13.125 13.5C12.525 13.5 12 12.975 12 12.375C12 11.775 12.525 11.25 13.125 11.25C13.725 11.25 14.25 11.775 14.25 12.375C14.25 12.975 13.725 13.5 13.125 13.5ZM4.875 13.5C4.275 13.5 3.75 12.975 3.75 12.375C3.75 11.775 4.275 11.25 4.875 11.25C5.475 11.25 6 11.775 6 12.375C6 12.975 5.475 13.5 4.875 13.5ZM14.175 6C14.025 5.55 13.575 5.25 13.125 5.25H4.875C4.35 5.25 3.975 5.55 3.825 6L2.25 10.5V16.5C2.25 16.95 2.55 17.25 3 17.25H3.75C4.2 17.25 4.5 16.95 4.5 16.5V15.75H13.5V16.5C13.5 16.95 13.8 17.25 14.25 17.25H15C15.45 17.25 15.75 16.95 15.75 16.5V10.5M6 0.75L9 4.125L12 0.75H6Z",
    fill: "#9091A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarLocation);
export default __webpack_public_path__ + "static/media/icon-car-location.51d41594a9a611f67195f66cc1914c45.svg";
export { ForwardRef as ReactComponent };